import { render, staticRenderFns } from "./UserHomeRedirect.vue?vue&type=template&id=08d685c2&scoped=true&"
import script from "./UserHomeRedirect.vue?vue&type=script&lang=js&"
export * from "./UserHomeRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d685c2",
  null
  
)

export default component.exports